import Toastr from '../../../itrust_common/components/Toastr'

const DEFAULT_STATE = {
  warranties: [],
  warrantiesMeta: {},
  eyeglasses: [],
  orderWarranties: [],
  orderWarrantiesMeta: {},
  orderWarrantyDetail: null,
  loading: false,
  eyeglassesLoading: false,
  orderWarrantiesLoading: false,
  orderWarrantyDetailLoading: false,
  saving: false,
}

function mergeList(existing, incoming, page) {
  if (page <= 1) return incoming
  const ids = new Set(existing.map((item) => item.id))
  return [...existing, ...incoming.filter((item) => !ids.has(item.id))]
}

export default function orderWarrantyReducer(state = DEFAULT_STATE, action) {
  const response = action.payload && (action.payload.data || action.payload.response)

  switch (action.type) {
    case 'ORDER_WARRANTIES_LOAD_PENDING':
      return { ...state, loading: true }

    case 'ORDER_WARRANTY_EYEGLASSES_LOAD_PENDING':
      return { ...state, eyeglassesLoading: true, eyeglasses: [] }

    case 'ORDER_APPLIED_WARRANTIES_LOAD_PENDING':
      return { ...state, orderWarrantiesLoading: true }

    case 'ORDER_WARRANTY_LOAD_PENDING':
      return { ...state, orderWarrantyDetailLoading: true, orderWarrantyDetail: null }

    case 'ORDER_WARRANTY_APPLY_PENDING':
    case 'ORDER_WARRANTY_USE_PENDING':
    case 'ORDER_WARRANTY_DELETE_PENDING':
      return { ...state, saving: true }

    case 'ORDER_WARRANTIES_LOAD_REJECTED':
      return { ...state, loading: false }

    case 'ORDER_WARRANTY_EYEGLASSES_LOAD_REJECTED':
      return { ...state, eyeglassesLoading: false, eyeglasses: [] }

    case 'ORDER_APPLIED_WARRANTIES_LOAD_REJECTED':
      return { ...state, orderWarrantiesLoading: false }

    case 'ORDER_WARRANTY_LOAD_REJECTED':
      return { ...state, orderWarrantyDetailLoading: false, orderWarrantyDetail: null }

    case 'ORDER_WARRANTY_APPLY_REJECTED':
    case 'ORDER_WARRANTY_USE_REJECTED':
    case 'ORDER_WARRANTY_DELETE_REJECTED': {
      const err = action.payload?.response?.data || action.payload?.data || {}
      const message = err?.meta?.message || err?.error || err?.message
      if (message) Toastr.handleShow(false, message, action.payload?.response?.status || 500)
      return { ...state, saving: false }
    }

    case 'ORDER_WARRANTIES_LOAD_FULFILLED':
      return {
        ...state,
        loading: false,
        warranties: mergeList(state.warranties, response?.warranties || [], action.meta?.page || 1),
        warrantiesMeta: response?.meta || {},
      }

    case 'ORDER_WARRANTY_EYEGLASSES_LOAD_FULFILLED':
      return { ...state, eyeglassesLoading: false, eyeglasses: response?.eyeglasses || [] }

    case 'ORDER_APPLIED_WARRANTIES_LOAD_FULFILLED':
      return {
        ...state,
        orderWarrantiesLoading: false,
        orderWarranties: mergeList(
          state.orderWarranties,
          response?.warranties || [],
          action.meta?.page || 1
        ),
        orderWarrantiesMeta: response?.meta || {},
      }

    case 'ORDER_WARRANTY_LOAD_FULFILLED':
      return {
        ...state,
        orderWarrantyDetailLoading: false,
        orderWarrantyDetail: response?.warranty || null,
      }

    case 'ORDER_WARRANTY_APPLY_FULFILLED':
      return { ...state, saving: false }

    case 'ORDER_WARRANTY_USE_FULFILLED': {
      const updated = response?.warranty
      if (response?.meta?.message) Toastr.handleShow(true, response.meta.message, 201)
      return {
        ...state,
        saving: false,
        orderWarrantyDetail: updated || state.orderWarrantyDetail,
        orderWarranties: updated
          ? state.orderWarranties.map((item) => (item.id === updated.id ? { ...item, ...updated } : item))
          : state.orderWarranties,
      }
    }

    case 'ORDER_WARRANTY_DELETE_FULFILLED': {
      const deletedId = response?.warranty?.id || action.meta?.warrantyId
      Toastr.handleShow(true, response?.meta?.message || 'Warranty deleted successfully', 201)
      return {
        ...state,
        saving: false,
        orderWarranties: state.orderWarranties.filter((item) => item.id !== deletedId),
        orderWarrantyDetail: state.orderWarrantyDetail?.id === deletedId
          ? null
          : state.orderWarrantyDetail,
      }
    }

    case 'ORDER_WARRANTIES_RESET':
      return {
        ...state,
        warranties: [],
        warrantiesMeta: {},
        eyeglasses: [],
        loading: false,
        eyeglassesLoading: false,
        saving: false,
      }

    case 'ORDER_APPLIED_WARRANTIES_RESET':
      return {
        ...state,
        orderWarranties: [],
        orderWarrantiesMeta: {},
        orderWarrantyDetail: null,
        orderWarrantiesLoading: false,
        orderWarrantyDetailLoading: false,
        saving: false,
      }

    default:
      return state
  }
}
